let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bs4gz")).then(() => parcelRequire('gYBzc'));